import React from "react";
import { Route } from "react-router";
import ConfirmRegistration from "../components/ConfirmRegistration";
import ResetPassword from "../components/ResetPassword";
import ConfirmInviteRegistration from "../components/ConfirmInviteRegistration";
import AccountLayout from "../components/AccountLayout";
import LoginPage from "../components/login/LoginPage";
import ForgotPasswordPage from "../components/ForgotPasswordPage";
import StartRegistrationPage from "../components/StartRegistrationPage";
import { UnauthorizedRoute } from "../../shared/components/Routers";

const useAccountRoutes = () => {
  return (
    <Route path="" element={<UnauthorizedRoute />}>
      <Route path="" element={<AccountLayout />}>
        <Route path="sign-in" element={<LoginPage />}></Route>
        <Route path="sign-up" element={<StartRegistrationPage />}></Route>
        <Route path="forgot-password" element={<ForgotPasswordPage />}></Route>
        <Route path="confirm-registration" element={<ConfirmRegistration />}></Route>
        <Route path="confirm-invite-registration" element={<ConfirmInviteRegistration />}></Route>
        <Route path="reset-password" element={<ResetPassword />}></Route>
      </Route>
    </Route>
  );
};

export default useAccountRoutes;